import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

function H2({ children }) {
  return (
    <h2 className="mt-10 font-display text-xl font-bold text-ink">{children}</h2>
  );
}

export default function SmsTerms() {
  return (
    <>
      <Seo
        title="SMS Terms | Web Pilot"
        description="Web Pilot SMS Terms: what messages we send, message frequency, rates, how to opt out with STOP, and how to get help. Links to our Privacy Policy."
      />

      <section className="bg-navy py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-skyblue">
              Legal
            </p>
            <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              SMS Terms
            </h1>
            <p className="mt-4 text-slate-300">Program name: Web Pilot</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-slate-600 sm:px-6">
          <H2>What you'll receive</H2>
          <p className="mt-3 leading-relaxed">
            When you opt in to messages from Web Pilot, you may receive:
          </p>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 leading-relaxed">
            <li>Follow-ups about your inquiry or free preview</li>
            <li>Appointment reminders and scheduling messages</li>
            <li>Updates about services you've asked us to set up</li>
          </ul>

          <H2>Frequency and cost</H2>
          <p className="mt-3 leading-relaxed">
            Message frequency varies. Message and data rates may apply.
          </p>

          <H2>Opting out</H2>
          <p className="mt-3 leading-relaxed">
            Text <strong>STOP</strong> to cancel. Text <strong>HELP</strong> for
            help. You can also email{" "}
            <a
              href="mailto:zach@webpilot.agency"
              data-testid="sms-terms-email-link"
              className="text-skyblue underline"
            >
              zach@webpilot.agency
            </a>
            .
          </p>

          <H2>Carriers</H2>
          <p className="mt-3 leading-relaxed">
            Carriers are not liable for delayed or undelivered messages.
          </p>

          <H2>Privacy</H2>
          <p className="mt-3 leading-relaxed">
            See our{" "}
            <Link
              to="/privacy"
              data-testid="sms-terms-privacy-link"
              className="text-skyblue underline"
            >
              Privacy Policy
            </Link>{" "}
            for how we handle your information.
          </p>
        </div>
      </section>
    </>
  );
}
